import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import { restorePhosphor } from "./utils/theme";

restorePhosphor();

createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
